import { createApp } from 'vue';
import { AccountLink } from '@rei/account-flyout';
import { getUser } from '@rei/session';
import getAdobeTargetJsonOffer from '@rei/adobe-target-functions';
import AccountLinkFragment from './components/AccountLinkFragment.vue';
import LoadingFragment from './components/LoadingFragment.vue';
import AccountNavComponent from './components/AccountNavComponent.vue';
import AccountFlyoutComponent from './components/AccountFlyoutComponent.vue';
import SignInNudgeComponent from './components/SignInNudgeComponent.vue';

const gNav = document.querySelector('.gnav');
const isWhiteNav = gNav !== null;
const { clientWidth } = window.document.body;

let isAccountMounted = false;
let isSignInNudgeMounted = false;

let user = null;
let signInType = 'control';
let rewardType = 'control';

if (isWhiteNav) {
  /* This is a default loading fragment that will display first and
    visually communicate to the user that something related to their
    account login is still pending.
  */
  // TODO: consider loading icon for mobile if test wins?
  createApp(LoadingFragment).mount('[data-ui="login-module-greeting"]');

  user = getUser()
    .then(async (userObj) => {
      user = userObj;
      if (clientWidth < 992) {
        const accountListItem = document.querySelector(
          '[data-ui="login-module-greeting-account-link"]',
        );
        try {
          const accountRewardsMobileNav = await getAdobeTargetJsonOffer(
            'account-rewards-mobile-nav',
          );
          if (accountRewardsMobileNav && accountRewardsMobileNav.length) {
            const [{ content }] = accountRewardsMobileNav;
            const [[{ experience }]] = content;
            rewardType = experience;
            if (rewardType === 'variant') {
              accountListItem.removeAttribute('data-visible');
            }
          }
        } catch (error) {
          console.error('Error with getAdobeTargetJsonOffer', error);
        }
      }
      if (user && user.isLoggedIn) {
        createApp(AccountNavComponent, { user, rewardType }).mount(
          '[data-ui="login-module-greeting-account-link"]',
        );
        const sentMemberViewMetric = sessionStorage.getItem('memberViewSent');
        if (
          window &&
          window.metrics &&
          user.membership &&
          !sentMemberViewMetric &&
          clientWidth < 992
        ) {
          window.metrics.click({
            siteId: 'global-sign-in',
            checkoutRewardsTotal: user.membership.dividendBalance || 0,
          });
          sessionStorage.setItem('memberViewSent', 'true');
        }
      } else {
        try {
          const evergreenSingInNudge = await getAdobeTargetJsonOffer(
            'evergreen-sign-in-nudge-component',
          );
          if (evergreenSingInNudge && evergreenSingInNudge.length) {
            const [{ content }] = evergreenSingInNudge;
            const [[{ experience }]] = content;
            signInType = experience;
          }
        } catch (e) {
          console.error('Error with getAdobeTargetJsonOffer', e);
        }
        createApp(AccountLinkFragment, { signInType }).mount(
          '[data-ui="login-module-greeting-account-link"]',
        );
      }

      const accountToggleButton = document.querySelector(
        "[data-ui='site-header-action-local-account']",
      );
      const navbarWrapper = document.querySelector("[data-ui='site-navigation']");

      // Mount account and set event listeners, this function will only be executed if the account
      // button is hover or focused. Otherwise there is no need to mount component
      const mountAccount = () => {
        isAccountMounted = true;
        // Insert <li> element next to account toggle button to render Account component
        accountToggleButton.parentNode.insertAdjacentHTML(
          'afterEnd',
          `<li class="account-dropdown ${
            isWhiteNav && 'account-dropdown--white-nav'
          }"><div id="account-placement"></div></li>`,
        );
        createApp(AccountFlyoutComponent, { user }).mount('#account-placement');
      };

      const signInLink = document.querySelector("[data-ui='login-module-greeting']");
      const mountSignInNudge = () => {
        isSignInNudgeMounted = true;

        signInLink.insertAdjacentHTML(
          'afterEnd',
          `<li class="sign-in-nudge-dropdown ${
            isWhiteNav && 'sign-in-nudge--white-nav'
          }"><div id="sign-in-nudge-placement"></div></li>`,
        );

        createApp(SignInNudgeComponent, { user, signInType }).mount('#sign-in-nudge-placement');
      };

      if (accountToggleButton && navbarWrapper && isWhiteNav) {
        ['focus', 'mouseenter'].forEach((eventName) =>
          accountToggleButton.addEventListener(
            eventName,
            () => {
              if (!isAccountMounted) {
                mountAccount();
              }
            },
            {
              once: true,
            },
          ),
        );

        window.addEventListener('load', () => {
          if (!isAccountMounted) {
            mountAccount();
          }
        });
      }

      if (signInLink && navbarWrapper && isWhiteNav) {
        setTimeout(() => {
          if (!isSignInNudgeMounted) {
            mountSignInNudge();
          }
        }, 2000);
      }
    })
    .catch(() => {
      createApp(AccountLink).mount('[data-ui="login-module-greeting"]');
    });
}
